import { size, SIZE } from 'assets/styles/ScreenSize';
import styled from 'styled-components/macro';
import { COLORS, FLEX_CONTAINER, FONTS, FONT_FAMILY } from 'utils/styles';

export const StyledOfferItemContainer = styled.div`
  border-radius: 16px;
  width: 100%;
  padding-right: 10px;
  padding-left: 10px;
`;

export const RequestItemWrapper = styled.div`
  width: 100%;
  padding: 10px 50px;

  @media only screen and (max-width: ${size.mobileL}) {
    padding: 10px 20px;
  }
`;

export const MessagesItemContentWrapper = styled.div`
  ${FLEX_CONTAINER.FlexRow};
`;

export const InfoWrapper = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  align-items: unset;
  padding-left: ${({ isSuggestion }) => (isSuggestion ? '30px' : '0px')};
  padding-right: ${({ isSuggestion }) => (isSuggestion ? '30px' : '0px')};
  padding-bottom: ${({ isSuggestion }) => (isSuggestion ? '20px' : '0')};

  @media only screen and (max-width: ${size.laptopL}) {
    ${FLEX_CONTAINER.FlexColumn};
    flex-direction: column-reverse;
    padding-left: ${({ isSuggestion }) => (isSuggestion ? '18px' : '0')};
    flex-wrap: wrap;
  }
`;

export const MessageInfoImage = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  width: 900px;
  height: ${({ isSuggestion }) => (isSuggestion ? '300px' : 'auto')};
  margin-right: ${({ isSuggestion }) => (isSuggestion ? '10px' : '0px')};

  @media only screen and (max-width: ${size.laptopL}) {
    width: 100%;
    margin-top: 10px;
  }

  @media only screen and (max-width: ${size.tablet}) {
    padding-left: ${({ isSuggestion }) => (isSuggestion ? '10px' : '0px')};
    padding-right: ${({ isSuggestion }) => (isSuggestion ? '10px' : '0px')};
  }
`;

export const OfferImg = styled.img`
  object-fit: contain;
  border-radius: 8px;
  width: 100%;
  display: flex;
  align-self: flex-start;
  justify-self: flex-start;
`;

export const FlexContainer = styled.div`
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}
`;

export const TitleAndPrice = styled.div`
  margin-bottom: ${({ suggestion }) => (suggestion ? '20px' : '10px')};
`;

export const StarsImg = styled.img``;

export const OfferInfo = styled.div`
  position: relative;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: ${({ isSuggestion }) => (isSuggestion ? '448px' : '400px')};
  padding-right: ${({ isRequest }) => (isRequest ? '12px' : '0')};
  padding-left: ${({ isRequest }) => (isRequest ? '47px' : '47px')};
  margin-bottom: ${({ isSuggestion }) => (isSuggestion ? '14px' : '0')};
  padding-right: ${({ isSuggestion }) => (isSuggestion ? '12px' : 'unset')};

  @media only screen and (max-width: ${size.laptopL}) {
    padding-left: ${({ isRequest }) => (isRequest ? '0px' : '6px')};
    overflow-x: hidden;
    overflow-y: ${({ isRequest }) => (isRequest ? 'scroll' : 'hidden')};
    padding-right: ${({ isRequest }) => (isRequest ? '10px' : '0')};
    height: ${({ isRequest }) => (isRequest ? '308px' : 'auto')};
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px ${COLORS.darkGray};
    background: ${COLORS.lightGray};
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${COLORS.mainColor};
    border-radius: 10px;
  }
`;

export const StyledTitle = styled.div`
  ${FONT_FAMILY.FontMedium};
  ${FONTS.font24};
  color: ${COLORS.mainColor};

  @media (min-width: ${SIZE.mobile}) {
    ${FONTS.font16}
    margin-bottom: 7px;
  }

  @media (min-width: ${SIZE.iphone}) {
    margin-bottom: 12px;
  }

  @media (min-width: ${SIZE.tablet}) {
    ${FONTS.font18}
    margin-bottom: 12px;
  }

  @media (min-width: ${SIZE.desktop}) {
    margin-bottom: 12px;
    ${FONTS.font20};
    line-height: 19px;
  }

  @media (min-width: ${SIZE.bigDesktop}) {
    ${FONTS.font24};
    line-height: 19px;
    margin-bottom: 14px;
  }
`;

export const StyledPrice = styled.div`
  color: ${COLORS.blue};
  font-weight: bold;
  position: absolute;
  right: 20px;
  top: 6px;

  @media (min-width: ${SIZE.mobile}) {
    ${FONTS.font16}
  }

  @media (min-width: ${SIZE.iphone}) {
    ${FONTS.font24}
  }

  @media (min-width: ${SIZE.tablet}) {
    ${FONTS.font24}
  }

  @media (min-width: ${SIZE.desktop}) {
    ${FONTS.font36}
  }

`;

export const CardText = styled.div`
  ${FLEX_CONTAINER.FlexRow};
  align-items: flex-start;
  margin-bottom: 14px;

  > p {
    ${FONT_FAMILY.FontMedium};
    font-weight: ${({ isLabel }) => isLabel && 600};
    color: ${COLORS.mainColor};

    @media (min-width: ${SIZE.mobile}) {
      ${FONTS.font14}
    }

    @media (min-width: ${SIZE.desktop}) {
      ${FONTS.font16}
    }

    @media (min-width: ${SIZE.bigDesktop}) {
      ${FONTS.font16}
    }
  }

  span {
    color: ${COLORS.mainColor};
    margin-left: 3px;

    @media (min-width: ${SIZE.mobile}) {
      ${FONTS.font14}
    }

    @media (min-width: ${SIZE.tablet}) {
      ${FONTS.font14}
    }

    @media (min-width: ${SIZE.desktop}) {
      ${FONTS.font16}
    }

    @media (min-width: ${SIZE.bigDesktop}) {
      ${FONTS.font16}
    }

    a {
      text-decoration: none;
    }
  }
`;

export const SampleSpan = styled.span`
  font-weight: ${({ isLabel }) => (isLabel ? 600 : 500)};
`;

export const SampleParagraph = styled.p``;

export const SampleAnotherPage = styled.a`
  color: ${COLORS.mainColor};
`;

export const SampleInfoText = styled.span`
  display: inline;

  > p {
    display: inline;
  }

  @media only screen and (max-width: ${SIZE.desktop}) {
    margin-right: unset;
  }
`;

export const OfferInfoTitle = styled.p`
  ${FONT_FAMILY.FontMedium};
  word-break: break-all;
  margin-left: 0;
`;

export const OfferInfoText = styled.span`
  ${FONT_FAMILY.FontMedium};
  margin-left: 0;
  ${FONT_FAMILY.FontRegular};
  word-break: break-word;
`;

export const ParagraphInfoText = styled.p``;

export const Description = styled.div`
  display: block;
  color: ${COLORS.mainColor};
  margin-left: 3px;
  word-break: break-word;

  > span {
    margin-left: 0;
    font-weight: 500;
  }

  > p {
    display: inline;
  }
`;

export const InfoSection = styled.div`
  margin-top: 10px;
  width: 100%;

  @media only screen and (max-width: ${SIZE.desktop}) {
    overflow-y: ${({ isSuggestion }) => (isSuggestion ? 'auto' : 'hidden')};
    height: ${({ isSuggestion }) => (isSuggestion ? '600px' : 'none')};
    margin-bottom: 20px;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px ${COLORS.darkGray};
      background: ${COLORS.lightGray};
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${COLORS.mainColor};
      border-radius: 10px;
    }
  }
  @media only screen and (max-width: ${SIZE.tablet}) {
    margin-bottom: unset;
  }
`;
